import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import { Button, MenuSelect } from "../components/Form";
import { BiDotsVerticalRounded, BiPlus } from "react-icons/bi";
import { HiOutlineMail } from "react-icons/hi";
import { RiDeleteBinLine } from "react-icons/ri";
import { toast } from "react-hot-toast";
import { TbBrandWhatsapp, TbMessage } from "react-icons/tb";
import CampaignModal from "../components/Modals/AddCampagnModal";
import { FiEye } from "react-icons/fi";
import axios from "axios";
import { BaseUrl } from "../BaseUrl"; // Make sure to import BaseUrl

function Campaings() {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState({});
  const [campaigns, setCampaigns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch Campaigns
  const fetchCampaigns = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BaseUrl}/facility/campaigns`, {
        withCredentials: true,
      });
      if (response.data.success) {
        setCampaigns(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching campaigns:", error);
      toast.error("Could not load campaigns");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCampaigns();
  }, []);

  const closeModal = () => {
    setIsOpen(!isOpen);
    setData({});
    if (isOpen) {
      // Refresh list when closing modal (potentially after create)
      fetchCampaigns();
    }
  };

  const actions = [
    {
      title: "View",
      icon: FiEye,
      onClick: (data) => {
        setIsOpen(true);
        setData(data);
      },
    },
    {
      title: "Delete",
      icon: RiDeleteBinLine,
      onClick: (item) => setDeleteConfirm(item),
    },
  ];

  /* Delete Modal Logic */
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  const handleDelete = async () => {
    if (!deleteConfirm) return;
    try {
      const response = await axios.delete(
        `${BaseUrl}/facility/campaigns/${deleteConfirm._id}`,
        { withCredentials: true }
      );
      if (response.data.success) {
        toast.success("Campaign deleted successfully");
        fetchCampaigns();
      }
    } catch (error) {
      console.error("Error deleting campaign:", error);
      toast.error(error.response?.data?.message || "Failed to delete campaign");
    } finally {
      setDeleteConfirm(null);
    }
  };

  return (
    <Layout>
      {/* Delete Confirmation Modal */}
      {deleteConfirm && (
        <div className='fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50'>
          <div className='mx-4 w-full max-w-md rounded-lg bg-white p-6 shadow-xl'>
            <h3 className='mb-4 text-lg font-semibold'>Confirm Delete</h3>
            <p className='mb-6 text-sm text-textGray'>
              Are you sure you want to delete{" "}
              <span className='font-semibold text-main'>
                {deleteConfirm.name}
              </span>
              ? This action cannot be undone.
            </p>
            <div className='flex justify-end gap-4'>
              <button
                onClick={() => setDeleteConfirm(null)}
                className='rounded-lg bg-[#B8B8B8] px-4 py-2 text-sm font-light text-white hover:opacity-80'
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className='rounded-lg bg-red-600 px-4 py-2 text-sm font-light text-white hover:opacity-80'
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {isOpen && (
        <CampaignModal
          isOpen={isOpen}
          closeModal={closeModal}
          data={data}
          onSuccess={fetchCampaigns}
        />
      )}
      <div className='flex-btn flex-wrap items-center gap-4'>
        <h1 className='text-xl font-semibold'>Campaigns</h1>
        <div className='xs:w-56'>
          <Button
            label='New Campaign'
            Icon={BiPlus}
            onClick={() => {
              setIsOpen(true);
              setData({});
            }}
          />
        </div>
      </div>

      {isLoading ? (
        <div className='py-12 text-center text-gray-500'>
          Loading campaigns...
        </div>
      ) : campaigns.length === 0 ? (
        <div className='py-12 text-center text-gray-500'>
          No campaigns found. Create one to get started!
        </div>
      ) : (
        <div className='my-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3'>
          {campaigns.map((item, index) => (
            <div
              key={item._id || index}
              className='rounded-xl border-[1px] border-border bg-white p-5'
            >
              <div className='grid grid-cols-12 items-center gap-4 border-b border-border pb-4'>
                <div className='col-span-2'>
                  <div
                    className={` ${item.type === "sms" && "bg-blue-500 text-blue-500"} ${item.type === "email" && "bg-orange-500 text-orange-500"} ${item.type === "whatsapp" && "bg-green-500 text-green-500"} flex-colo h-12 w-full rounded bg-opacity-10 text-lg`}
                  >
                    {item.type === "email" && <HiOutlineMail />}
                    {item.type === "sms" && <TbMessage />}
                    {item.type === "whatsapp" && <TbBrandWhatsapp />}
                  </div>
                </div>
                <div className='col-span-8'>
                  <h1 className='truncate text-sm font-light'>{item.title}</h1>
                  <p className='mt-1 text-xs font-medium text-gray-400'>
                    {item.sendTo}
                  </p>
                </div>
                <div className='col-span-2'>
                  <MenuSelect datas={actions} item={item}>
                    <div className='flex-colo h-12 w-12 rounded text-lg hover:bg-[#0095D9] hover:bg-opacity-10 hover:text-[#0095D9]'>
                      <BiDotsVerticalRounded />
                    </div>
                  </MenuSelect>
                </div>
              </div>
              {/* message */}
              <div className='mt-4 flex flex-col gap-3'>
                <h4 className='text-sm font-medium'>Message</h4>
                <p className='line-clamp-2 text-xs leading-5 text-textGray'>
                  {item.message}
                </p>
                <div className='mt-2 flex items-center justify-between gap-2'>
                  <span className='rounded-xl border border-border bg-dry px-3 py-1 text-xs text-textGray'>
                    {item.date}
                  </span>
                  <span
                    className={`rounded px-2 py-0.5 text-[10px] font-semibold ${item.status === "Sent" ? "bg-green-100 text-green-600" : "bg-gray-100 text-gray-600"}`}
                  >
                    {item.status}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}

export default Campaings;
